var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgAzureWhite = function SvgAzureWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 22",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.022 20.688c3.616-.64 6.603-1.17 6.637-1.177l.062-.014-3.414-4.07a578 578 0 0 1-3.414-4.09c0-.021 3.526-9.753 3.545-9.788.007-.011 2.406 4.141 5.816 10.066l5.849 10.162.044.078-10.85-.001-10.85-.002zM0 19.447c0-.006 1.609-2.805 3.575-6.221L7.15 7.015l4.166-3.505C13.607 1.583 15.488.003 15.496 0a.7.7 0 0 1-.067.17l-4.524 9.726-4.443 9.553-3.231.004c-1.777.002-3.231 0-3.231-.006"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAzureWhite);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;